import { fetch } from '@utils/utils';
import * as T from '@modules/hr-shifts/_shiftsTypes';

const getShift = ({ addError }) => async (id: string): Promise<T.Shift | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/shift/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Shift = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const getAllShifts = ({ addError }) => async (): Promise<string | null> => {
  try {
    const response = await fetch(`/metropolis/api/hr/workplan/shift/parametrized`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ pageSize: 9999 })
    });

    const json = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

export { getShift, getAllShifts };



// WEBPACK FOOTER //
// ./src/modules/hr-shifts/_shiftsActions.ts